import './Gallery.scss';
import image1 from '../../../assets/images/banner3.jpg';
import image2 from '../../../assets/images/banner4.jpg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React from "react";
import Slider from "react-slick";

const Gallery = ({images}) => {
    const assetUrl = process.env.REACT_APP_TAURIAN_ASSET_URL;
    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <button className="custom-prev-arrow b-none bg-transparent absolute l-0 fs-500 p-25" onClick={onClick}>
                <i class="fa-solid fa-chevron-left"></i>
            </button>
        );
    };

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <button className="custom-next-arrow b-none bg-transparent absolute r-0 fs-500 p-25" onClick={onClick}>
                <i class="fa-solid fa-chevron-right"></i>
            </button>
        );
    };

    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    };

    return (
        <div className="gallery pb-300 px-md-400 py-md-200">

            <Slider {...settings}>
                {
                    images?.map((image)=>{
                        return(
                            <div className="image-container align-items-center jc-center"><img className="slide-image" src={`${assetUrl}${image}`} /></div>   
                        )

                    })
                }    
                

                

            </Slider>
        </div>
    );
};

export default Gallery;